import { InverseHeader } from '@jouzen/ecom-components/layout';
import { useGateValue } from '@statsig/react-bindings';

import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

const IntegrationsHero = () => {
  const isBiomarkersEnabled = useGateValue('biomarkers_rollout');

  const squareSrc = `${isBiomarkersEnabled ? '/integrations/hero-mobile.jpg' : '/blue-sky/integrations/hero-v2.png'}?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.6&fp-y=0.5&fp-z=1.1`;
  const landscapeSrc = `${isBiomarkersEnabled ? '/integrations/hero-desktop.jpg' : '/blue-sky/integrations/hero-v2.png'}?ar=3:2&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=1`;

  return (
    <InverseHeader enter>
      <LandingPageHero
        backgroundImage={{
          localizedAlt: isBiomarkersEnabled
            ? 'heart_health_man_closeup_alt'
            : 'integrations_hero_alt_text',
          srcSet: [
            {
              media: '(max-width: 1023px)',
              src: squareSrc,
            },
            {
              media: '(min-width: 1024px) and (orientation: landscape)',
              src: landscapeSrc,
            },
            {
              media: '(max-width: 1199px) and (orientation: portrait)',
              src: squareSrc,
            },
          ],
        }}
        backgroundProps={{
          color: 'sandstone-200',
          gradients: [],
        }}
        copy="integrations_hero_copy"
        data-cy="integrations-hero"
        eyebrow="integrations_hero_eyebrow"
        textColor="text-sandstone-200"
        title="integrations_hero_title"
        titleProps={{
          indentation: 'lg:pl-28',
          typographyProps: {
            className: 'lg:en:whitespace-nowrap',
          },
        }}
      />
    </InverseHeader>
  );
};

export default IntegrationsHero;
